import React from 'react'

import { BSModalButton } from '@components'
import { BonusSystemDeclineState, BonusSystemState, BonusesDeclineMessage, BonusesEvents } from 'game-ui-types'
import { Bonus } from '@amusnet/mgs-ws-client'
import { useTranslation } from '@amusnet/translations/react'

interface DeclineButtonsTemplateProps {
    bonus?: Bonus
    bonusSystemDeclineState: string
    setBonusSystemState: (state: string) => void
    setBonusSystemDeclineState: (state: string) => void
    setDeclinedBonusesIds: (id: string) => void
}

const DeclineButtonsTemplate: React.FC<DeclineButtonsTemplateProps> = ({
    bonus,
    bonusSystemDeclineState,
    setBonusSystemState,
    setBonusSystemDeclineState,
    setDeclinedBonusesIds,
}: DeclineButtonsTemplateProps) => {
    const { t } = useTranslation()

    const isInSingleBonusDeclineState = bonusSystemDeclineState === BonusSystemDeclineState.SINGLE_BONUS_DECLINE
    const isInMultipleBonusesDeclineState = bonusSystemDeclineState === BonusSystemDeclineState.MULTIPLE_BONUSES_DECLINE
    const isInBundleDeclineState = bonusSystemDeclineState === BonusSystemDeclineState.BUNDLE_DECLINE

    const noClickHandler = (): void => {
        setBonusSystemState(
            isInSingleBonusDeclineState
                ? BonusSystemState.SINGLE_BONUS_INITIAL
                : BonusSystemState.MULTIPLE_BONUSES_INITIAL
        )
        setBonusSystemDeclineState('')
    }

    const yesClickHandler = (): void => {
        setBonusSystemDeclineState('')

        if (isInMultipleBonusesDeclineState) {
            // TODO if decline returns as functionality we'll need to handle declining multiple bonuses of the same type
            // const declineMultipleBonusesMessage: BonusesDeclineMessage = {
            //     type: BonusesEvents.DECLINE,
            //     payload: { bonusIds: bonuses.map((b) => b.id) }
            // }
            //
            // window.uiBus.postMessage(declineMultipleBonusesMessage)
            setBonusSystemState(BonusSystemState.INACTIVE)
        } else if (isInSingleBonusDeclineState && bonus) {
            const declineSingleBonusMessage: BonusesDeclineMessage = {
                type: BonusesEvents.DECLINE,
                payload: { bonusIds: [bonus.id] },
            }

            window.uiBus.postMessage(declineSingleBonusMessage)

            setDeclinedBonusesIds(bonus.id)
            setBonusSystemState(BonusSystemState.INACTIVE)
        } else if (isInBundleDeclineState && bonus) {
            const declineSingleBonusMessage: BonusesDeclineMessage = {
                type: BonusesEvents.DECLINE,
                payload: { bonusIds: [bonus.id] },
            }

            window.uiBus.postMessage(declineSingleBonusMessage)

            setDeclinedBonusesIds(bonus.id)
            setBonusSystemState(BonusSystemState.MULTIPLE_BONUSES_INITIAL)
        }
    }

    return (
        <div className="flex justify-between gap-[20px] py-[27px] w-full px-[85px]">
            <BSModalButton id="confirm-decline" text={t('gameui.yes')} isPrimary={false} onClick={yesClickHandler} />
            <BSModalButton id="cancel-decline" text={t('gameui.no')} onClick={noClickHandler} />
        </div>
    )
}

export default DeclineButtonsTemplate
